module.exports = __webpack_public_path__ + "img/profile-4.02f28c80.png";